<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de requisição">
            <template v-slot:actions>
                <rkm-button
                    v-if="additionals && additionals.salaVacinacaoLogada && !!additionals.salaVacinacaoLogada.id"
                    @click="$router.push({ name: 'imunizacao-requisicao-create' })"
                    color="primary"
                    authorize="store-imunizacao-requisicao"
                >
                    Cadastrar requisição
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List @loaded="handleLoaded" />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/imunizacao/requisicao/List'

export default {
    components: { List },
    data: () => ({
        additionals: null,
    }),
    methods: {
        handleLoaded(additionals) {
            this.additionals = additionals
        },
    },
}
</script>